import React, { createContext, useCallback, useContext, useEffect, useState } from 'react';
import { fetchData, postData, putData, deleteData } from '../../services/Api';
import { useAlert } from '../geral/AlertContext';
import { useMessage } from '../geral/MessageContext';

const DestaqueProdutoContext = createContext();

export const useDestaqueProduto = () => useContext(DestaqueProdutoContext);

const buildPayload = (destaqueProduto) => ({
    id: Number(destaqueProduto?.id) || 0,
    titulo: destaqueProduto?.titulo?.trim() || '',
});

const extractErrorMessage = (error) => {
    if (error?.errors && typeof error.errors === 'object') {
        return Object.entries(error.errors)
            .flatMap(([field, messages]) => {
                const list = Array.isArray(messages) ? messages : [messages];
                return list.map((message) => `${field}: ${message}`);
            })
            .join('\n');
    }

    return error?.title || error?.message || String(error);
};

export const DestaqueProdutoProvider = ({ children }) => {
    const [destaqueProdutos, setDestaqueProdutos] = useState([]);
    const { showAlert } = useAlert();
    const { showMessage } = useMessage();

    const fetchDestaqueProdutos = useCallback(async () => {
        try {
            const result = await fetchData('/DestaqueProduto');
            setDestaqueProdutos(result || []);
        } catch (error) {
            console.error('Erro ao buscar destaques de produtos:', error);
            showMessage(`Erro ao buscar destaques de produtos!\n${extractErrorMessage(error)}`, 'danger');
        }
    }, [showMessage]);

    useEffect(() => {
        fetchDestaqueProdutos();
    }, [fetchDestaqueProdutos]);

    const addDestaqueProduto = async (destaqueProduto) => {
        try {
            const result = await postData('/DestaqueProduto', buildPayload(destaqueProduto));
            setDestaqueProdutos((current) => [...current, result]);
            showAlert('Destaque de produto adicionado com sucesso!');
            return result;
        } catch (error) {
            console.error('Erro ao adicionar destaque de produto:', error);
            showMessage(`Erro ao adicionar destaque de produto!\n${extractErrorMessage(error)}`, 'danger');
            throw error;
        }
    };

    const updateDestaqueProduto = async (destaqueProduto) => {
        try {
            const result = await putData('/DestaqueProduto', buildPayload(destaqueProduto));
            setDestaqueProdutos((current) =>
                current.map((item) => (item.id === result.id ? result : item)),
            );
            showAlert('Destaque de produto alterado com sucesso!');
            return result;
        } catch (error) {
            console.error('Erro ao alterar destaque de produto:', error);
            showMessage(`Erro ao alterar destaque de produto!\n${extractErrorMessage(error)}`, 'danger');
            throw error;
        }
    };

    const deleteDestaqueProduto = async (id) => {
        try {
            await deleteData('/DestaqueProduto', { destaqueProdutoId: id });
            setDestaqueProdutos((current) => current.filter((item) => item.id !== id));
            showAlert('Destaque de produto excluido com sucesso!');
        } catch (error) {
            console.error('Erro ao excluir destaque de produto:', error);
            showMessage(`Erro ao excluir destaque de produto!\n${extractErrorMessage(error)}`, 'danger');
            throw error;
        }
    };

    return (
        <DestaqueProdutoContext.Provider
            value={{
                destaqueProdutos,
                fetchDestaqueProdutos,
                addDestaqueProduto,
                updateDestaqueProduto,
                deleteDestaqueProduto,
            }}
        >
            {children}
        </DestaqueProdutoContext.Provider>
    );
};
